var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramFestaTabM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 68,
    viewBox: "0 0 57 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 20L18.5 10L28.5 0L38.5 10L28.5 20ZM22.034 10L28.5 16.466L34.966 10L28.5 3.53396L22.034 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.2089L24.291 9.99996L28.5 5.79102L32.7089 9.99996L28.5 14.2089ZM27.825 9.99996L28.5 10.6749L29.1749 9.99996L28.5 9.32498L27.825 9.99996Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.709 25.1494H23.7512V42.8468H26.709V25.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.77 25.1494H31.8123V42.8468H34.77V25.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1074 32.0114L24.754 34.8818L25.7092 37.701L34.0626 34.8305L33.1074 32.0114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3897 25.1729H10V28.1516H20.3897V25.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.676 26.6621H13.7183V42.8276H16.676V26.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6244 44L36.8169 33.3901L43.3239 24L45.7465 25.7021L40.4554 33.3381L47 42.2269L44.6244 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8123 31.877H38.6385V34.8557H45.8123V31.877Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2203 66.8153L49.7521 54.2199L45.5379 66.7916L42.7394 65.8388L48.3176 49.2092L49.5498 49.1998L51.1067 49.1855L57 65.8151L54.2203 66.8153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9244 61.6625L49.8757 59.5977L47.8271 61.6625L49.8757 63.7273L51.9244 61.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95371 67.3312H0V51.6545L7.20084 48.668L8.32494 51.4174L2.95371 53.6455V67.3312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15224 56.5934L0.867188 59.4629L2.08597 62.1746L8.37102 59.3051L7.15224 56.5934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0483 67.5121L22.2281 65.1656L26.4047 61.8804L21.1558 55.4287L27.9756 48.4033L30.0874 50.4844L25.1207 55.6041L30.6095 62.3498L24.0483 67.5121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7488 49.1279H32.3638V52.1049H42.7488V49.1279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0332 50.6162H36.0795V66.7859H39.0332V50.6162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4307 68L9.62781 57.3909L16.1278 48L18.5501 49.7018L13.2635 57.3387L19.8012 66.2271L17.4307 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6159 55.8789H11.448V58.8559H18.6159V55.8789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "white",
    transform: "translate(10 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    fill: "white",
    transform: "translate(0 48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFestaTabM);
export default __webpack_public_path__ + "static/media/programFestaTabM.0f785e5c26eb43768e39c8b4391298e1.svg";
export { ForwardRef as ReactComponent };